import { GUIDE_CATEGORY_PLATFORM } from 'app/pages/guides/main/pages/constants';
import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { guidesKeyes } from './guidesKeyes';
import { useTranslation } from 'react-i18next';

export interface EditableGuides {
  guideCategoryId: number;
  userId: number;
  customerId: number;
  name: string;
  order: number;
  private: boolean;
  createdAt: string;
  updatedAt: string;
}

const renameCategory = async ({
  name,
  platform,
  categoryId,
}: {
  name: number[];
  platform: GUIDE_CATEGORY_PLATFORM;
  categoryId: number;
}): Promise<EditableGuides[]> => {
  return (
    await EXPRESS_API.patch(`guide-category/${categoryId}/edit`, {
      name,
      platform,
    })
  ).data as EditableGuides[];
};
export const useRenameCategoryMutation = (closeModalHandler: () => void) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation(renameCategory, {
    onError: err => showError(err),
    onSuccess: (_, variables) => {
      successToast({ title: t('You have successfully renamed category!') });
      queryClient.invalidateQueries(guidesKeyes.categorized());
      queryClient.refetchQueries(
        guidesKeyes.singleCategory(`${variables.categoryId}`)
      );
      queryClient.invalidateQueries(guidesKeyes.editableCategories());
      closeModalHandler();
    },
  });
};
